var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BannerSection',{staticClass:"hero-wrapper bg-dark",style:({backgroundImage: ("url(" + _vm.imgurl + ")")})},[_vm._t("default",[_vm._v("I'm a hero section!")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }